import { Theme } from "@mui/material";
const background = {
  default: "#F2F4F6",
  paper: "#F2F4F6",
} as const;

const primaryColor = {
  light: "#C6CEEE",
  main: "#2E5ED5",
  dark: "#2E5ED5",
  contrastText: "#FFF",
} as const;

const secondaryColor = {
  light: "#989A9C",
  main: "#4C6283",
  dark: "#334C71",
  contrastText: "#FFF",
} as const;

const successColor = {
  light: "#DAFBEE",
  main: "#00C067",
  dark: "#004D29",
  contrastText: "#fff",
} as const;

const warningColor = {
  light: "#FFF5E1",
  main: "#FFA300",
  dark: "#CC8200",
  contrastText: "#CC8200",
} as const;

const infoColor = {
  light: "#ECEEFB",
  main: "#425CC7",
  dark: "#2E408A",
  contrastText: "#FFF",
} as const;

const errorColor = {
  light: "#FAE5EE",
  main: "#CC0042",
  dark: "#AA0045",
  contrastText: "#AA0045",
} as const;

const purple = {
  light: "#5546FF",
  main: "#5546FF",
  dark: "#5546FF",
  contrastText: "#fff",
} as const;

export const palette: Partial<Theme["palette"]> = {
  mode: "light",
  background: {
    ...background,
  },
  primary: {
    ...primaryColor,
  },
  secondary: {
    ...secondaryColor,
  },
  success: {
    ...successColor,
  },
  error: {
    ...errorColor,
  },
  info: {
    ...infoColor,
  },
  warning: {
    ...warningColor,
  },

  // customGray: {
  //   ...customGray
  // },
  purple: {
    ...purple,
  },
} as const;
